import { Capacitor } from '@capacitor/core';

export type AdsProviderKind = 'none' | 'demo' | 'web' | 'admob';
export type IapProviderKind = 'none' | 'demo' | 'store';

export interface MonetizationConfig {
  enabled: boolean;
  ads: {
    banner: boolean;
    interstitial: boolean;
    rewarded: boolean;
    interstitialEveryRuns: number;
  };
  iap: {
    removeAds: boolean;
    cosmetics: boolean;
    shop: boolean;
  };
  revive: {
    enabled: boolean;
    maxPerRun: number;
    timeSeconds: number;
  };
  adsProvider: AdsProviderKind;
  iapProvider: IapProviderKind;
  demo: boolean;
  testingAds: boolean;
  childDirected: boolean;
  ids: {
    webAdClient: string;
    webBannerSlot: string;
    bannerAdUnit: string;
    interstitialAdUnit: string;
    rewardedAdUnit: string;
    removeAdsProduct: string;
    skinProductPrefix: string;
    revenueCatApiKey: string;
    leaderboardUrl: string;
    analyticsEndpoint: string;
    cfAnalyticsToken: string;
    supportUrl: string;
  };
}

export const MONETIZATION: MonetizationConfig = {
  enabled: true,
  ads: {
    banner: true,
    interstitial: true,
    rewarded: true,
    interstitialEveryRuns: 5,
  },
  iap: {
    removeAds: true,
    cosmetics: true,
    shop: true,
  },
  revive: {
    enabled: true,
    maxPerRun: 1,
    timeSeconds: 12,
  },
  adsProvider: 'none',
  iapProvider: 'none',
  demo: false,
  testingAds: true,
  childDirected: false,
  ids: {
    webAdClient: '',
    webBannerSlot: '',
    bannerAdUnit: 'ca-app-pub-3940256099942544/6300978111',
    interstitialAdUnit: 'ca-app-pub-3940256099942544/1033173712',
    rewardedAdUnit: 'ca-app-pub-3940256099942544/5224354917',
    removeAdsProduct: 'remove_ads',
    skinProductPrefix: 'skin_',
    revenueCatApiKey: '',
    leaderboardUrl: 'https://crazyclock-leaderboard.jamesizcool7.workers.dev',
    analyticsEndpoint: 'https://crazyclock-leaderboard.jamesizcool7.workers.dev/events',
    cfAnalyticsToken: 'f6c4495885ae4d4fae4cd58021802375',
    supportUrl: '',
  },
};

export function isMonetizationActive(): boolean {
  return MONETIZATION.enabled;
}

export function isNativePlatform(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

export function defaultAdsProvider(): AdsProviderKind {
  return isNativePlatform() ? 'admob' : 'web';
}

export function defaultIapProvider(): IapProviderKind {
  return isNativePlatform() ? 'store' : 'none';
}

export function applyMonetizationOverrides(search: string): void {
  MONETIZATION.adsProvider = defaultAdsProvider();
  MONETIZATION.iapProvider = defaultIapProvider();
  const params = new URLSearchParams(search);
  const mode = params.get('monetization');
  if (mode === 'off') {
    MONETIZATION.enabled = false;
    MONETIZATION.adsProvider = 'none';
    MONETIZATION.iapProvider = 'none';
    return;
  }
  if (mode === 'demo') {
    MONETIZATION.enabled = true;
    MONETIZATION.demo = true;
    MONETIZATION.adsProvider = 'demo';
    MONETIZATION.iapProvider = 'demo';
    return;
  }
}
